import { render, staticRenderFns } from "./ConfirmBankForm.vue?vue&type=template&id=4c5242fc&"
import script from "./ConfirmBankForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmBankForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports